import Logo from "../../assets/Logo";
import { Link } from "react-router-dom";
import ContactIcons from "./ContactIcons";

const NavBar = () => {
  return (
    <div className="navbar bg-base-100 sticky top-0 z-50">
      <div className="navbar-start">
        <Link to="/">
          <Logo fill="black" />
        </Link>
      </div>
      <div className="navbar-end hidden lg:flex" id="desktop">
        <ul className="menu menu-horizontal px-1">
          <li>
            <ContactIcons />
          </li>
          <li>
            <Link to="/">HOME</Link>
          </li>
          <li>
            <Link to="/about">ABOUT</Link>
          </li>
          <li>
            <Link to="/services">SERVICES</Link>
          </li>
        </ul>
      </div>
      <div className="navbar-end lg:hidden" id="mobile-menu">
        <a
          href="sms:+1-914-912-1497"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          book now
        </a>
        <div className="dropdown dropdown-end">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li>
              <Link to="/">HOME</Link>
            </li>
            <li>
              <Link to="/about">ABOUT</Link>
            </li>
            <li>
              <Link to="/services">SERVICES</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
